import { jsx as t } from "react/jsx-runtime";
import { i as l } from "../../../type-BFTbooL7.js";
function s(r) {
  const {
    className: i,
    value: e
  } = r;
  return l(e) ? null : /* @__PURE__ */ t("div", { className: i, children: e });
}
export {
  s as default
};
